export const PHONE_NUMBER = '+355 68 655 5556';
export const PHONE_HREF = `tel:${PHONE_NUMBER.replace(/[^+\d]/g, '')}`;
export const EMAIL = 'TaxiReady2Go@hotmail.com';
export const ADDRESS = 'Margarita Tutulani, Tirana';

export const whatsappHref = (message) =>
  `https://wa.me/${PHONE_NUMBER.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;

// Google Business rating. The badge in the reviews section stays hidden until
// all three are filled in with the real values from the Google profile.
export const GOOGLE_RATING = null; // e.g. 4.9
export const GOOGLE_REVIEW_COUNT = null; // e.g. 120
export const GOOGLE_PROFILE_URL = ''; // e.g. https://g.page/r/...

export const LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'it', name: 'Italiano' },
  { code: 'de', name: 'Deutsch' },
  { code: 'fr', name: 'Français' },
  { code: 'es', name: 'Español' },
];

export const FARES = { toCity: 18, toAirport: 15 };

// Facts used by the Privacy Policy, Terms and Cookie Policy. Anything left as
// null shows on those pages as a highlighted "[to be added]" marker.
// TODO(owner): fill these in, and have a local lawyer review the pages.
export const LEGAL = {
  lastUpdated: '10 October 2026',
  businessName: null, // registered business name, as on the QKB extract
  nipt: null, // NIPT (tax identification number)
  registeredAddress: null, // registered address of the business
  hostingLocation: null, // e.g. "Germany" or "Finland" (where the Hetzner server is)
  bookingRetention: null, // e.g. "5 years, as required by Albanian tax and accounting law"
  logRetention: null, // e.g. "30 days"
  paymentMethods: null, // e.g. "cash (EUR or ALL) or card, paid to the driver"
  includedWaiting: null, // e.g. "60 minutes after your flight lands"
  freeCancellation: null, // e.g. "up to 2 hours before pickup"
  lateCancellationFee: null, // e.g. "50% of the fare" or "none"
  maxPassengers: null, // e.g. "4 passengers per car"
  complaintReplyDays: 14,
};

// Shown on the home page and the About page, so they always match.
// TODO(owner): replace with the exact current figures.
export const STATS = {
  customers: 10000,
  drivers: 50,
  years: new Date().getFullYear() - 2020, // About page: "Founded in 2020"
};

const PHOTO_DIR = '/images/taxiready2go-photos';
export const photo = (name, ext) => `${PHOTO_DIR}/${name}.${ext}`;
